import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import keywordListingPageQuery from './query.graphql';

const KeywordListingPage = loadable(
  () => import(/* webpackChunkName: "keyword-listing" */ './keyword-listing'),
  {
    fallback: <Loader />,
  }
);

KeywordListingPage.graphQL = keywordListingPageQuery;

KeywordListingPage.variables = ({ id, limit, random }) => ({
  ids: id.split(','),
  limit: typeof limit === 'string' ? limit.replace(/[^\d]/g, '') : 3000,
  includeRandom:
    typeof random === 'string'
      ? ['1', 'true', 'yes'].includes(random.toLocaleLowerCase())
      : false,
});

export default KeywordListingPage;
